var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Keyboard'),_c('Messages'),_c('div',{staticClass:"d-flex flex-column align-center justify-center",staticStyle:{"height":"100%"}},[_c('Login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }